<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      v-bind="attrs"
      v-on="on"
    >
      <template v-slot:activator="{ on }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTooltip }">
            <v-btn color="indigo" dark icon
              v-on="getHandlers(on, onTooltip)"
            >
              <v-icon>history</v-icon>
            </v-btn>
          </template>
          <span>履歴</span>
        </v-tooltip>
      </template>
      <v-card class="pa-2">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class='mb-2'>交換履歴</v-list-item-title>
              <v-divider></v-divider>
              <v-list-item-subtitle>機械名:{{kki_nm}}</v-list-item-subtitle>
              <v-list-item-subtitle>部品名:{{bhn_nm}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-data-table
          dense
          no-data-text="データがありません"
          :loading="loading"
          loading-text="読み込み中です"
          :headers="headers"
          :items="history"
          hide-default-footer
        ></v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false" color="indigo">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios.js'
export default {
  props: {
    hsh_cd: String,
    kki_nm: String,
    bhn_nm: String
  },
  data () {
    return {
      loading: true,
      menu: false,
      message: false,
      hints: true,
      headers: [
        {
          text: 'No',
          align: 'start',
          sortable: false,
          value: 'rrk_no'
        },
        {text: '交換日', value: 'kukn_dt', sortable: false}
      ],
      history: []
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      // ログインセッションを確認できなければログイン画面に遷移する
      if (!(status && result)) {
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
        this.$store.dispatch('appSetting/fLogin')
      } else {
        // 保守点検の交換履歴情報を取得する
        myAxios.get('api/hshtnkn_mstr/hshtnkn_master_kiyk_kuknrrk', {hsh_tnkn_cd: this.hsh_cd}).then(res => {
          // 0が帰ってきたらリストアイテムは空にする
          if (res.data === 0) {
            this.history = []
            this.loading = false
          } else {
            this.history = res.data[1]
            this.loading = false
          }
        })
      }
    })
  },
  methods: {
    getHandlers () {
      return [...arguments].reduce((seed, item) => {
        const mergedHandlers = { ...item, ...seed }
        return mergedHandlers
      }, {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/HshTnknMstr/HshTnknMstrRrk.vue